export default __webpack_public_path__ + "static/media/full_logo.45d3e490.png";